import React, { useState, useEffect } from 'react';
import {
  Button,
  ButtonProps,
  CircularProgress,
  Menu,
  MenuItem
} from '@material-ui/core';
import { ArrowDropDown as ArrowDropDownIcon } from '@material-ui/icons';
import AppSnackbar from '../../../common/AppSnackbar';
import { Training } from '../Training.interface';
import { useExportTrainingPlan } from '../Training.hooks';

export interface TrainingPlanExportButtonProps {
  training?: Training;
  buttonProps?: ButtonProps;
}

const TrainingPlanExportButton: React.FC<TrainingPlanExportButtonProps> = (
  props: TrainingPlanExportButtonProps
) => {
  const { training, buttonProps } = props;
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  const [{ isLoading, error, response }, getDocument, downloadDocument] =
    useExportTrainingPlan(training?.id || 0);

  const getDocumentAs = (option: 'all' | 'current') => {
    getDocument(option);
  };

  useEffect(() => {
    if (response?.ok && training) {
      downloadDocument(`Training Plan - ${training.id}.pdf`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  return (
    <>
      <AppSnackbar severity='error' open={!!error}>
        {error?.message || 'An error occurred while exporting the document.'}
      </AppSnackbar>
      <Button
        color='primary'
        variant='contained'
        endIcon={
          isLoading ? (
            <CircularProgress color='primary' size={20} />
          ) : (
            <ArrowDropDownIcon />
          )
        }
        {...buttonProps}
        disabled={isLoading || buttonProps?.disabled}
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          setMenuAnchorEl(event.currentTarget);
        }}
      >
        Export
      </Button>
      <Menu
        id='training-export-menu'
        keepMounted
        open={!!menuAnchorEl}
        anchorEl={menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            getDocumentAs('current');
          }}
        >
          Export Current Version
        </MenuItem>

        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null);
            getDocumentAs('all');
          }}
        >
          Export All Versions
        </MenuItem>
      </Menu>
    </>
  );
};
export default TrainingPlanExportButton;
